import React from 'react';
import moment from 'moment';
import { getRevisionsUrlFromSlug } from '../../utilities/urlHelper';
import { canViewRevision } from '../../utilities/permissionsUtilities';

class PageLastUpdatedTitle extends React.Component {
    getTitle = () => {
        const { page } = this.props;

        if (!page || !page.created_at || !page.updated_at) return null;

        const createdAgo = moment.utc(page.created_at).fromNow();
        const updatedAgo = moment.utc(page.updated_at).fromNow();
        const verifiedAgo = page.verified_at ? moment.utc(page.verified_at).fromNow() : null;

        let createdAndUpdated = `Created ${createdAgo}`;

        if (createdAgo !== updatedAgo) {
            createdAndUpdated += `, last updated ${updatedAgo}`;
        }

        if (page.verification_schedule_id && verifiedAgo) {
            createdAndUpdated += `, last verified ${verifiedAgo}`;
        }

        return createdAndUpdated;
    };

    render() {
        const { page } = this.props;
        const title = this.getTitle();

        if (!title) return null;

        const showRevisionLink = page.can_update || canViewRevision();

        if (!showRevisionLink) {
            return (
                <p className="gray">
                    {title}
                </p>
            );
        }

        const { page: { slug } } = this.props;

        return (
            <p>
                <a className="gray" href={getRevisionsUrlFromSlug(slug)}>{title}</a>
            </p>
        );
    }
}

export default PageLastUpdatedTitle;
